import { render, staticRenderFns } from "./AccountTransferCategorization.vue?vue&type=template&id=c72e6326&"
import script from "./AccountTransferCategorization.vue?vue&type=script&lang=js&"
export * from "./AccountTransferCategorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports